// extracted by mini-css-extract-plugin
export var guideBox = "TalkGuide-module--guideBox--ba2b6";
export var guideMessage = "TalkGuide-module--guideMessage--5453b";